"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page404 = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Page404 = () => (react_1.default.createElement("div", { className: styles_scss_1.default.page404 },
    react_1.default.createElement("img", { src: constants_1.Images.page404, alt: "404" }),
    react_1.default.createElement("h3", { className: styles_scss_1.default.title }, constants_1.default.general.pageNotFoundTitle),
    react_1.default.createElement(components_1.HelperText, { className: styles_scss_1.default.helperText }, constants_1.default.general.pageNotFound),
    react_1.default.createElement(components_1.Link, { className: styles_scss_1.default.link, to: constants_1.Routes.Home, color: "rgb(255, 255, 255)", hoverColor: "rgb(255, 255, 255)" }, constants_1.default.general.goBack)));
exports.Page404 = Page404;
exports.default = exports.Page404;
